module.exports = __webpack_public_path__ + "img/logodemo2.ae168c0b.png";